import React from "react";
import "./eda-description.scss";
function DescriptionCard() {
  return (
    <div>
      <div className="stats-section">
        <ul className="summary-stats">
          <li>
            <span>N Values:</span>
            <span>{"150"}</span>
          </li>
          <li>
            <span>N Distinct:</span>
            <span>{"92"}</span>
          </li>
          <li>
            <span>Mode:</span>
            <span>{"1"}</span>
          </li>
          <li>
            <span>N Empty:</span>
            <span>{"0"}</span>
          </li>
          <li>
            <span>N Mode:</span>
            <span>{"2"}</span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default DescriptionCard;
